import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../../api";
import functions from "../../../../functions";

import ParadigmaAsyncSeeker from "../../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import { Col, Input, Row, Table } from 'reactstrap';
import imgNotAvailable from "../../../../../public/img/image-not-found.png";


class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            Nombre: "",
            Imagen: "",
            CondicionDePago: [],
            OpcionesDePago: [{
                NroCuotas: 0,
                PorcentajeRecargo: 0,
                PorcentajeDescuento: 0,
            }],
            CantidadPlanes: 1,
            postVariables: ["Nombre", "Imagen", "CondicionDePago", "OpcionesDePago"],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'DELETE', 'EDIT', 'DETAIL']).isRequired,
    }

    resetForm() {
        this.setState({
            id: null,
            Nombre: "",
            Imagen: "",
            CondicionDePago: [],
            OpcionesDePago: [{
                NroCuotas: 0,
                PorcentajeRecargo: 0,
                PorcentajeDescuento: 0,
            }],
            CantidadPlanes: 1,
            errors: [],
        });
    }

    getData() {
        const { postVariables } = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });
        data.OpcionesDePago = data.OpcionesDePago.map(item => ({
            NroCuotas: parseInt(item.NroCuotas),
            PorcentajeDescuento: parseInt(item.PorcentajeDescuento),
            PorcentajeRecargo: parseInt(item.PorcentajeRecargo),
        })).filter(item => item.NroCuotas > 0);
        return data;
    }

    setData(data) {
        if (data.success) {
            this.setState({
                id: data.id,
                Nombre: data.Nombre,
                Imagen: data.Imagen,
                CondicionDePago: data.CondicionDePago,
                OpcionesDePago: data.OpcionesDePago,
                CantidadPlanes: data.OpcionesDePago.length
            })
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nueva Tarjeta",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "La Tarjeta ha sido creada con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Tarjeta",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "La Tarjeta ha sido editada con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Tarjeta",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Tarjeta",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "La Tarjeta ha sido eliminada con éxito.",
                saveButton: true,
                saveButtonLabel: "Eliminar",
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    updateCantidadPlanes(newLength) {
        const OpcionesDePago = Array.from(Array(newLength).keys()).map(_ => ({
            NroCuotas: 0,
            PorcentajeRecargo: 0,
            PorcentajeDescuento: 0,
        }));

        for (let i = 0; i < newLength; i++) {
            if (i < this.state.OpcionesDePago.length)
                OpcionesDePago[i] = { ...this.state.OpcionesDePago[i] };
        }

        this.setState({ OpcionesDePago: OpcionesDePago, CantidadPlanes: newLength });
    }

    updatePlan(index, prop, value) {
        const OpcionesDePago = [...this.state.OpcionesDePago];
        OpcionesDePago[index][prop] = value;
        this.setState({ OpcionesDePago: OpcionesDePago });
    }

    updateImage(evt) {
        evt.preventDefault();
        let node = document.getElementById("raised-button-file");
        if (node != undefined && node != null && node.files != null && node.files.length == 1) {
            const reject = (Image) => this.onChangeField('Imagen', Image);
            const resolve = (resizedImage) => this.onChangeField('Imagen', resizedImage);
            //functions.resizeBase64Img(690, node.files[0]).then(resolve).catch(reject);
            functions.getB64ImageFromInputFile(node.files[0]).then(resolve).catch(reject);
        }
    }

    render() {
        let vars = this.modalVars();
        const { action } = this.props;

        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.gestion.ventas.tarjetas : null)}
                submitUrl={(vars.submitType ? api.gestion.ventas.tarjetas : null)}
                submitType={vars.submitType}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e) & this.resetForm()}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                saveReloadButton={action == "CREATE"}
                saveReloadButtonLabel="Guardar y Nuevo"
                closeButton={true}
            >
                <Row>
                    <Col>
                        <label htmlFor={"raised-button-file"} className="m-0 w-100" title="Abrir Explorador de Archivos">
                            <div className="text-center mx-auto">
                                <img height={50} className="rounded" src={
                                    this.state.Imagen == undefined || this.state.Imagen == null || this.state.Imagen == "" ?
                                        imgNotAvailable
                                        :
                                        this.state.Imagen
                                } alt="Imagen Novedad" />
                            </div>
                        </label>
                        <input type="file" accept="image/*" id={"raised-button-file"} name={"raised-button-file"} style={{ color: "transparent" }} className={vars.disabled == true ? "d-none" : "d-block"}
                            onChange={evt => this.updateImage(evt)}
                        />
                    </Col>
                </Row>
                <ParadigmaLabeledInput
                    disabled={vars.disabled}
                    md={[4, 8]}
                    label={"Nombre"}
                    value={this.state.Nombre}
                    onChange={(e) => this.onChangeField('Nombre', e.target.value)}
                    error={() => this.getError('Nombre')}
                />
                <ParadigmaLabeledInput
                    md={[4, 8]}
                    label={"Condición de Pago"}
                    inputComponent={
                        <ParadigmaAsyncSeeker
                            disabled={vars.disabled}
                            url={api.gestion.ventas.condicionesdepago}
                            value={this.state.CondicionDePago}
                            valueField="Codigo"
                            displayField="Nombre"
                            multiselect={true}
                            parameters={{ paginationEnabled: "False", filters: ["DeBaja=False"], sort: ["Nombre"] }}
                            onChange={(data) => this.onChangeField('CondicionDePago', data.map(item => item.Codigo))}
                        />
                    }
                    error={() => this.getError('TipoDocumento_id')}
                />
                <hr />
                <ParadigmaLabeledInput
                    md={[4, 8]}
                    label={"Cantidad de Planes"}
                    inputComponent={
                        <Input
                            type="select"
                            value={this.state.CantidadPlanes}
                            onChange={(e) => this.updateCantidadPlanes(parseInt(e.target.value))}
                            disabled={vars.disabled}
                        >
                            <option value={1}>1 Plan</option>
                            {
                                Array.from(Array(31).keys()).filter(item => item > 1).map(val => (
                                    <option key={`plan-${val}`} value={val}>{val} Planes</option>
                                ))
                            }
                        </Input>
                    }
                    error={() => this.getError('TipoDocumento_id')}
                />
                <Table outline className="mt-2">
                    <thead>
                        <tr>
                            <th>Cantidad de Cuotas</th>
                            <th>% Recargo</th>
                            <th>% Descuento</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.OpcionesDePago.map((condPago, index) => (
                                <tr key={`plan-cuota-${index}`}>
                                    <td>
                                        <Input
                                            type="number" min={0}
                                            onChange={(evt) => this.updatePlan(index, 'NroCuotas', evt.target.value)}
                                            value={condPago['NroCuotas']}
                                            disabled={vars.disabled}
                                        />
                                    </td>
                                    <td>
                                        <Input
                                            type="number" min={0} max={100}
                                            onChange={(evt) => this.updatePlan(index, 'PorcentajeRecargo', evt.target.value)}
                                            value={condPago['PorcentajeRecargo']}
                                            disabled={vars.disabled}
                                        />
                                    </td>
                                    <td>
                                        <Input
                                            type="number" min={0} max={100}
                                            value={condPago['PorcentajeDescuento']}
                                            onChange={(evt) => this.updatePlan(index, 'PorcentajeDescuento', evt.target.value)}
                                            disabled={vars.disabled}
                                        />
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </Table>
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Gestion/Ventas/Tarjetas/Modal.js